
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsOtherPaymentDialog extends Serenity.EntityDialog<PsOtherPaymentRow, any> {
        protected getFormKey() { return PsOtherPaymentForm.formKey; }
        protected getIdProperty() { return PsOtherPaymentRow.idProperty; }
        protected getLocalTextPrefix() { return PsOtherPaymentRow.localTextPrefix; }
        protected getNameProperty() { return PsOtherPaymentRow.nameProperty; }
        protected getService() { return PsOtherPaymentService.baseUrl; }
        protected getDeletePermission() { return PsOtherPaymentRow.deletePermission; }
        protected getInsertPermission() { return PsOtherPaymentRow.insertPermission; }
        protected getUpdatePermission() { return PsOtherPaymentRow.updatePermission; }

        protected form = new PsOtherPaymentForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            
            
            var id = this.entity.Id
            if (id<9) {
                this.applyChangesButton.toggleClass('disabled', true);
                // Serenity.EditorUtils.setReadOnly(this.form.paymentChannel, true);
            }

            

        }

    }
}